import { HeadingProps } from '@src/components/atoms/heading/types';

import { H } from './styles';

const Heading = ({
  level = 'h1',
  asLevel,
  children,
  centered = false,
  className,
  id,
  textTransform = 'uppercase',
}: HeadingProps) => (
  <H
    id={id}
    as={asLevel ?? level}
    className={className}
    $textTransform={textTransform}
    $level={level}
    $centered={centered}
  >
    {children}
  </H>
);
export default Heading;
